<template>
<div>
  <EVCurrentData></EVCurrentData>
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3">
      <Calendar numpickers=1></Calendar>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-9 order-xl-first">
      <EVChart :data="data"></EVChart>
    </div>
  </div>
</div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue'
import EVCurrentData from './EVCurrentData.vue'
import EVChart from './EVChart.vue'
import Calendar from './Calendar.vue'
import VueSlider from 'vue-slider-component'

import '../assets/vendor/datetimepicker/js/bootstrap-datetimepicker.min.js' 

export default {
  name: 'ElectricVehicles',
  components: {
    LoadingSpinner,
    EVCurrentData,
    EVChart,
    Calendar,
    VueSlider
  },
  data(){
    return {
    }
  },
  computed: {
    data: function(){
      return this.$store.getters.data 
    } 
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
